// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import { Message, Loading, MessageBox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios"
import Vueaxios from "vue-axios"
import store from './store'

// const frontendOnly = process.env.FRONTEND_ONLY === 'true'

// if (frontendOnly) {
//   const user = {
//     Id: 'frontend-dev',
//     Img: '',
//     TelePhone: '13800000000',
//     Name: process.env.DEV_USER_NAME || '前端开发',
//     Bm: process.env.DEV_USER_DEPARTMENT || '前端开发',
//     tokenstr1: 'frontend-only-token'
//   }
//   Object.keys(user).forEach(key => window.localStorage.setItem(key, user[key]))
//   store.commit('user/setToken', 'frontend-only-token')
//   router.beforeEach((to, from, next) => {
//     if (to.name === 'login') {
//       next({ name: 'home' })
//       return
//     }
//     next()
//   })
// }

Vue.use(Vueaxios, axios)

Vue.prototype.$axios = axios;

import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);

// 创建全局事件总线  
Vue.prototype.$eventBus = new Vue();
// 导入腾讯地图，获取用户当前位置

import { VueJsonp } from 'vue-jsonp';

Vue.prototype.$jsonp = VueJsonp

Vue.use(VueJsonp)

Vue.use(ElementUI);
// 解决单选框报错问题
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});

// 考勤计算出来是星期几
Vue.prototype.$getWeekDay = function(dateString) {
  const daysOfWeek = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const date = new Date(dateString);
  return daysOfWeek[date.getDay()];
};

Vue.config.productionTip = false

// 声明请求拦截器
let loadingInstance = ''
// 防止401弹窗重复出现
let isShowing401Dialog = false

axios.interceptors.request.use((config) => {
  // if (frontendOnly) {
  //   config.adapter = () => Promise.resolve({
  //     data: { code: 204, msg: [] },
  //     status: 200,
  //     statusText: 'Frontend Only',
  //     headers: {},
  //     config,
  //     request: {}
  //   })
  //   return config
  // }
  if (config.url != '/api/Course/RuleUploadFile' && config.url != '/api/User/LoginWX' && config.url != '/api/User/Sign' && config.url != '/api/WxPay/GetOrderStatus'
    && config.url != '/api/User/GetInfo' && config.url != '/api/Statistics/GetMsg' && config.url != '/api/Statistics/EditRead'
    && config.url != '/api/WxPay/GetPayCode' && config.url != '/api/User/GetEmployeeStatus' && config.url != '/api/Work/GetAgentCount'
    && config.url != '/api/User/EditSchedule' && config.url != '/api/User/GetSchedule' && config.url != '/api/Work/EditIsFp'
    && config.url != '/api/Work/GetMsgdetailed' && config.url != '/api/Personnel/GetPendingform' && config.url != '/api/ReviewAccess/GetPendingformACCESS'
  ) {
    // 展示 Loading 效果
    loadingInstance = Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.6)', spinner: 'el-icon-loading' });
  }
  // 先获取token
  const token = store.state.user.token
  // 判断是否存在token，如果存在，需要设置请求头
  if (token) {
    config.headers['token'] = token
  }
  return config
})

// 声明响应拦截器
axios.interceptors.response.use((response) => {
  // 隐藏 Loading 效果
  if (loadingInstance) {
    loadingInstance.close();
  }
  if (response.data.code === 501) {
    Message.error({
      message: response.data.msg,
    });
  } else if (response.data.code === 500) {
    Message.error({
      message: response.data.msg,
    });
  } else if (response.data.code === 502) {
    Message.error({
      message: response.data.msg,
    });
    // router.push({ name: 'index' })
  } else if (response.data.code === 401) {
    // 防止重复弹窗
    if (isShowing401Dialog) {
      return Promise.reject(response);
    }
    isShowing401Dialog = true;

    // ===== 触发断开SignalR连接 =====
    Vue.prototype.$eventBus.$emit('disconnectSignalR');
    // 使用 MessageBox.alert 弹窗，只有一个关闭按钮
    MessageBox.alert(response.data.msg, '提示', {
      confirmButtonText: '关闭',
      center: true,
      showClose: false,           // 不显示右上角关闭按钮
      closeOnClickModal: false,   // 点击遮罩不关闭
      closeOnPressEscape: false,  // 按 ESC 不关闭
      type: 'warning',
      callback: () => {
        isShowing401Dialog = false;  // 重置标志
        // 点击关闭按钮后跳转
        router.push({ name: 'login' });
      }
    });
  } else if (response.data.code === 400) {
    Message.error({
      message: response.data.msg,
    });
  }

  if (response && response.data && response.data.code === 205) {
    // 说明token失效,需要清空失效的token,然后跳转到登录页
    store.commit('user/removeToken')
    // ===== 触发断开SignalR连接 =====
    Vue.prototype.$eventBus.$emit('disconnectSignalR');
    router.push('/login')
    // 提示信息
    Message({
      message: '登录信息失效,请重新登录', // message后端返回的错误信息
      type: 'error',
    })
  }
  return response
}, function (error) {
  if (loadingInstance) {
    loadingInstance.close()
  }
  if (error.config) {
    if (error.config.url !== '/api/SignUp/OrderQuery') {
      if (error.response && error.response.status) {
        let statusC = error.response.status
        // 401 已经在成功拦截器中处理了弹窗，这里只处理其他错误码
        if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503 || statusC == 504) {
          Message.error({
            message: '错误提示' + statusC,
          });
        } else if (statusC == 401) {
          // 防止重复弹窗（兜底处理，如果成功拦截器没有处理）
          if (!isShowing401Dialog) {
            isShowing401Dialog = true;
            Vue.prototype.$eventBus.$emit('disconnectSignalR');
            const errMsg = (error.response.data && error.response.data.msg) || '登录信息失效，请重新登录';
            MessageBox.alert(errMsg, '提示', {
              confirmButtonText: '关闭',
              center: true,
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'warning',
              callback: () => {
                isShowing401Dialog = false;
                router.push('/login');
              }
            });
          }
        }
      }
    }
  }
  return Promise.reject(error.config);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js